/**
 * Languages supported by LumApps.
 * Intentionally CommonJS with no browser API references — safe to require from Node.js tooling.
 */

const defaultSupportedLanguages = [
    'ar',
    'az',
    'bg',
    'bn',
    'bs',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'en',
    'es',
    'et',
    'fr',
    'fr_ca',
    'hi',
    'hr',
    'hu',
    'id',
    'it',
    'is',
    'ja',
    'ko',
    'ku',
    'lt',
    'lv',
    'nl',
    'no',
    'pl',
    'pt',
    'pt_br',
    'ro',
    'ru',
    'sk',
    'sl',
    'sr',
    'sv',
    'ta',
    'th',
    'tl',
    'tr',
    'uk',
    'vi',
    'zh',
    'zh_hk',
    'zh_tw',
];

module.exports = { defaultSupportedLanguages };
